import { RouterV2Enum } from '@/router/router-names';
import { AgreementTypeEnum } from '@/enums/agreement-type';
import { AgreementSceneType } from '@/api/agreement/types';
import { CallBackActionEnum, PageVersionTypeEnums, EvokeAppTypeEnums } from './types';

export enum LandingPageType {
  /** 登录分屏版本 */
  SPLIT = 'SPLIT',
  /** 一屏登录 */
  FULL = 'FULL'
}

export interface pageConfigType {
  /** 页面展示板式 */
  pageType?: LandingPageType;
  /** 是否需要进入页面唤起下载app */
  notCallAppWhenEnter?: boolean;
  /** 无需自动下载app */
  notAutoDownApp?: boolean;
  /** 按钮执行的回调类型 */
  buttonCalllBackType?: CallBackActionEnum;
  /** 按钮名称 */
  buttonName?: string;
  /** 角标类型 */
  icon?: string;
  /** 输入框默认展示文案 */
  placeholder?: string;
  /** 风险提示文案 */
  riskTips?: string;
  /** 渠道包下载地址 */
  channelDownloadUrl?: string;
  /** 输入框的图标 */
  inputLeftIcon?: string;
  /** 利率风格，默认红色 */
  interestValueTheme?: string;
  /** 是否展示权益模块 */
  showRight?: boolean;
  /** 隐藏「一千元最低0.3元/天」文案，默认隐藏 */
  hidenPrerateDes?: boolean,
  /** 自定义利率描述文案 */
  rateDes?: string;
  /** 不否展示利率说明文案部分 */
  notShowProductDescription?: boolean;
  /** 点击按钮ios场景下不需要唤起哈啰app */
  iosNotOpenApp?: boolean
  /** 唤起app应用类型(哈啰app/哈臻快/微信小程序) */
  evokeAppType?: EvokeAppTypeEnums;
  /** 页面标题 */
  documentTitle?: string;
  /** 关闭ios主动唤起app功能 */
  isCloseIosEvokeApp?: boolean;
  /** 底部优势列表配置(默认是3个：息费透明、最快30秒放款、循环额度) */
  advantageList?: { icon: string, text: string }[],
  /** 一键登录模式：不展示手机输入框、协议勾选 */
  isAutoLogin?: boolean;
  /** 风险提示文案wisdom配置key，若没配置则默认取riskTipsConfigKey.VERSION_ONE */
  riskTipsConfigKey?: riskTipsWisdomKeyEnum;
}

/** 腾讯侧-落地页的优势列表配置 */
const tencentAdvantageList = [
  { icon: 'crystal', text: '息费透明' },
  { icon: 'hello', text: '哈啰旗下' },
  { icon: 'round', text: '循环额度' },
];


/** 风险提示wisdom配置对应key
 * wisdom配置平台地址：https://config.hellobike.cn/#/mobile/detail?env=fat&teamName=%E5%93%88%E5%95%B0%E5%87%BA%E8%A1%8C-%E9%87%91%E8%9E%8D-H5
 */
export enum riskTipsWisdomKeyEnum {
  VERSION_ONE = 'AppFinanceH5Web.LandingPage',
  VERSION_TWO = 'AppFinanceH5Web.LandingPage2',
}

export enum buttonNameEnum {
  WITHDRAW = '去提现',
  OPEN_BROWSER_DOWNLOAD = '打开浏览器下载app',
}

/** 013配置 */
const BRAND_VERSION_RISK_CONFIG: pageConfigType = {
  pageType: LandingPageType.SPLIT,
  buttonCalllBackType: CallBackActionEnum.DOWNLOAD,
  notCallAppWhenEnter: true,
  buttonName: '立即申请',
  icon: 'hasNoneBadge',
  placeholder: '请输入手机号（已加密）',
};

/** 014配置 */
const BRAND_VERSION_BAIDU_CONFIG: pageConfigType = {
  ...BRAND_VERSION_RISK_CONFIG,
  channelDownloadUrl: 'https://cdn.51downapp.cn/hellobike/android/channel/a0010044.apk',
};

/** 015配置 */
const RIGHT_VERSION_CONFIG: pageConfigType = {
  ...BRAND_VERSION_BAIDU_CONFIG,
  inputLeftIcon: '',
  interestValueTheme: 'grey',
  showRight: true,
};

/** 016配置 */
const BRAND_VERSION_RISK_BG_CONFIG: pageConfigType = {
  ...BRAND_VERSION_RISK_CONFIG,
  rateDes: '综合年化利率(单利)4.9%-24%',
};

/** TODO：配置化重构方案：1.底部头图抽离 2.申请按钮角标 */
export const pageFeatureConfig: Map<
  PageVersionTypeEnums, pageConfigType
> = new Map([
  [PageVersionTypeEnums.NEW_VERSION_WITHAB, { notAutoDownApp: true }],
  [PageVersionTypeEnums.BRAND_VERSION_WITHLOGIN_AND_INFO,
    {
      pageType: LandingPageType.SPLIT,
      rateDes: '综合年化利率(单利)4.9%-24%',
    }],
  [PageVersionTypeEnums.BRANDVERSIONWITHLOGINANDINFO_WITHOUT_ANDROIDJUMP,
    {
      pageType: LandingPageType.SPLIT,
      notCallAppWhenEnter: true,
      rateDes: '综合年化利率(单利)4.9%-24%',
    }],
  [PageVersionTypeEnums.BRANDVERSIONWITHELE, {
    pageType: LandingPageType.SPLIT,
    notCallAppWhenEnter: true,
    notShowProductDescription: true,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_DOWNLOAD,
    {
      pageType: LandingPageType.SPLIT,
      buttonCalllBackType: CallBackActionEnum.DOWNLOAD,
      buttonName: '下载app查看额度',
      icon: 'coupon',
    }],
  [PageVersionTypeEnums.BRAND_VERSION_COUPON,
    {
      pageType: LandingPageType.SPLIT,
      buttonCalllBackType: CallBackActionEnum.GO_TO_INFO_PAGES,
      buttonName: '查看我的额度',
      icon: 'coupon',
      notCallAppWhenEnter: true,
    }],
  [PageVersionTypeEnums.BRAND_VERSION_RISK, {
    ...BRAND_VERSION_RISK_CONFIG,
    advantageList: tencentAdvantageList,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_BAIDU, BRAND_VERSION_BAIDU_CONFIG],
  [PageVersionTypeEnums.RIGHT_VERSION, RIGHT_VERSION_CONFIG],
  [PageVersionTypeEnums.BRAND_VERSION_RISK_BG, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    advantageList: tencentAdvantageList,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_BAIDU_017, {
    ...BRAND_VERSION_BAIDU_CONFIG,
    notShowProductDescription: true,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_RISK_BG_018, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    notShowProductDescription: true,
    advantageList: tencentAdvantageList,
  }],
  [PageVersionTypeEnums.BRANDVERSIONWITHLOGIN_019, {
    iosNotOpenApp: true,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_BYTEDANCE_020, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    notShowProductDescription: true,
    buttonName: '查看我的额度',
    evokeAppType: EvokeAppTypeEnums.RECHARGE,
    documentTitle: '哈臻快',
  }],
  [PageVersionTypeEnums.BRAND_VERSION_TENCENT_021, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    buttonName: '查看我的额度',
    evokeAppType: EvokeAppTypeEnums.RECHARGE,
    documentTitle: '哈臻快',
  }],
  /** 哈臻快-短信唤起营销页 */
  [PageVersionTypeEnums.EVOKE_APP_MARKET_RECHARGE, {
    evokeAppType: EvokeAppTypeEnums.RECHARGE,
    documentTitle: '哈臻快',
    isCloseIosEvokeApp: true,
  }],
  /** 臻有钱-微信小程序营销页配置 */
  [PageVersionTypeEnums.EVOKE_APP_MARKET_FINANCE_WX_MP, {
    evokeAppType: EvokeAppTypeEnums.FINANCE_WX_MP,
    documentTitle: '臻有钱',
  }],
  /** 记账app-短信唤起营销页 TODO: 先不用这个版本 */
  [PageVersionTypeEnums.EVOKE_APP_MARKET_SKZHENXH, {
    evokeAppType: EvokeAppTypeEnums.SKZHENXH,
    // documentTitle: '记账app', // 待确认文档标题
    isCloseIosEvokeApp: true, // 根据需求配置
  }],
  [PageVersionTypeEnums.FINANCE_MAIN_BYTEDANCE, {
    ...BRAND_VERSION_BAIDU_CONFIG,
    notShowProductDescription: true,
  }],
  [PageVersionTypeEnums.BRAND_AUTO_LOGIN_BYTEDANCE, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    notShowProductDescription: true,
    buttonName: '查看额度',
    isAutoLogin: true,
  }],
  [PageVersionTypeEnums.BRAND_AUTO_LOGIN_TENCENT, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    advantageList: tencentAdvantageList,
    buttonName: '查看额度',
    isAutoLogin: true,
  }],
  [PageVersionTypeEnums.NOT_CALL_WHEN_ENTER_ELM, {
    notCallAppWhenEnter: true,
    riskTipsConfigKey: riskTipsWisdomKeyEnum.VERSION_TWO,
  }],
  [PageVersionTypeEnums.BRAND_VERSION_TENCENT_029, {
    ...BRAND_VERSION_RISK_BG_CONFIG,
    notShowProductDescription: true,
    advantageList: tencentAdvantageList,
    riskTipsConfigKey: riskTipsWisdomKeyEnum.VERSION_TWO,
  }],
]);
/** 主动唤起app的页面(兼容sms-download历史页面) */
export const EvokeAppRouteNames = [
  RouterV2Enum.smsDownload,
  RouterV2Enum.evokeAppMarket,
];

/** 协议列表页，普通版url的参数链接拼接 */
export const getAutoLoginLegalContractRoute = ():
  string => `${RouterV2Enum.legalConstract}?contractType=${AgreementTypeEnum.MARKET}&sceneType=${AgreementSceneType.SMS}&isNeedLogin=false&h5NewWebview=true`;
